import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'vnCurrencyString',
})
export class VnCurrencyStringPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  static ChuSo = new Array('không ', ' một', ' hai', ' ba', ' bốn', ' năm', ' sáu', ' bảy', ' tám', ' chín');
  static Tien = new Array('', ' nghìn', ' triệu', ' tỷ', ' nghìn tỷ', ' triệu tỷ');

  static DocSo3ChuSo(baso: any): any {
    let tram;
    let chuc;
    let donvi;
    let KetQua = '';
    tram = parseInt('' + baso / 100, 0);
    // eslint-disable-next-line radix
    chuc = parseInt('' + (baso % 100) / 10, 0);
    donvi = parseInt('' + (baso % 10), 0);

    console.log(tram, chuc, donvi);
    if (tram === 0 && chuc === 0 && donvi === 0) return '';
    if (tram !== 0) {
      KetQua += this.ChuSo[tram] + ' trăm';
      if (chuc === 0 && donvi !== 0) KetQua += ' linh ';
    }
    if (chuc !== 0 && chuc !== 1) {
      KetQua += this.ChuSo[chuc] + ' mươi';
      if (chuc === 0 && donvi !== 0) KetQua = KetQua + ' linh ';
    }
    if (chuc === 1) KetQua += ' mười';
    switch (donvi) {
      case 1:
        if (chuc !== 0 && chuc !== 1) {
          KetQua += ' mốt ';
        } else {
          KetQua += this.ChuSo[donvi];
        }
        break;
      case 5:
        if (chuc === 0) {
          KetQua += this.ChuSo[donvi];
        } else {
          KetQua += ' lăm ';
        }
        break;
      default:
        if (donvi !== 0) {
          KetQua += this.ChuSo[donvi];
        }
        break;
    }
    return KetQua;
  }

  //2. Hàm đọc số thành chữ (Sử dụng hàm đọc số có ba chữ số)
  static getMoneyString(SoTien: any): any {
    let lan = 0;
    let i = 0;
    let so = 0;
    let KetQua = '';
    let tmp = '';
    let ViTri = new Array();
    if (SoTien < 0) return 'Số tiền âm !';
    if (SoTien === 0) return 'Không đồng !';
    if (SoTien > 0) {
      so = SoTien;
    } else {
      so = -SoTien;
    }
    if (SoTien > 8999999999999999) {
      //SoTien = 0;
      return 'Số quá lớn!';
    }
    ViTri[5] = Math.floor(so / 1000000000000000);
    if (isNaN(ViTri[5])) ViTri[5] = '0';
    so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
    ViTri[4] = Math.floor(so / 1000000000000);
    if (isNaN(ViTri[4])) ViTri[4] = '0';
    so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
    ViTri[3] = Math.floor(so / 1000000000);
    if (isNaN(ViTri[3])) ViTri[3] = '0';
    so = so - parseFloat(ViTri[3].toString()) * 1000000000;
    ViTri[2] = parseInt('' + so / 1000000, 0);
    if (isNaN(ViTri[2])) ViTri[2] = '0';
    ViTri[1] = parseInt('' + (so % 1000000) / 1000, 0);
    if (isNaN(ViTri[1])) ViTri[1] = '0';
    ViTri[0] = parseInt('' + (so % 1000), 0);
    if (isNaN(ViTri[0])) ViTri[0] = '0';
    if (ViTri[5] > 0) {
      lan = 5;
    } else if (ViTri[4] > 0) {
      lan = 4;
    } else if (ViTri[3] > 0) {
      lan = 3;
    } else if (ViTri[2] > 0) {
      lan = 2;
    } else if (ViTri[1] > 0) {
      lan = 1;
    } else {
      lan = 0;
    }
    for (i = lan; i >= 0; i--) {
      tmp = this.DocSo3ChuSo(ViTri[i]);
      KetQua += tmp;
      if (ViTri[i] > 0) KetQua += this.Tien[i];
      if (i > 0 && tmp.length > 0) KetQua += '';
    }
    if (KetQua.substring(KetQua.length - 1) === '') {
      KetQua = KetQua.substring(0, KetQua.length - 1);
    }
    KetQua = KetQua.substring(1, 2).toUpperCase() + KetQua.substring(2);
    return KetQua; //.substring(0, 1);//.toUpperCase();// + KetQua.substring(1);
  }

  transform(value: number): any {
    if (value) {
      return VnCurrencyStringPipe.getMoneyString(value);
    }
    return value;
  }
}
